module.exports = __webpack_public_path__ + "static/img/fivedragons_esp.80ae213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivedragons_esp.png
// module id = p9We
// module chunks = 1